import './profile.css'
import { user } from '../../apicall';

export default function Profile() {
  // const url = 'www.linkedin.com/in/jayesh-gawade-87bb47131'
  const url = user[0].linkdin
  return (
    <div className='profilecntr'>
      <div className='imgcntr'>
        <img src={user[0].IMG} alt='profileimg' />
      </div>
      <h4>{user[0].username}</h4>
      <p>{user[0].email}</p>
      <h4>Linkdin Link</h4>
      <a href={`//${url}`} className="linkdin" target="_blank" rel="noopener noreferrer">
        {user[0].linkdin}
      </a>
      <div className='last-box'>
        <div className='education'>
          <h4>My Education</h4>
          {user[0].education.map((item, i)=>{
            return (<p key={i}>{item}</p>)
          })}
        </div>

        <div className='skills'>
          <h4>Skills</h4>
          <div className='the-skills'>
          {user[0].skills.map((item, i) => {
            return (<span key={i}>{item + ","}</span>)
          })}
          </div>
        </div>
      </div>
    </div>
  )
}
